import React from "react";
import {Button, Col, Row, Table} from "react-bootstrap";
import {ResponseType} from "./ResponseType";
import {getMessage} from "../util";

const NotFound = (props:ResponseType) => {
    return(
        <Row className={"justify-content-center"}>
            <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>
                <Table striped bordered hover>
                    <tbody>
                    <tr>
                        <th>{getMessage('id', props.messages)}</th>
                        <td>No está empadronado</td>
                    </tr>
                    </tbody>
                </Table>
                <p className={"lead"}>{getMessage('not_found', props.messages)}</p>
                <Button variant="light" className="EvColorBlue text-white m-1" target="_blank" href="https://evoting.typeform.com/to/C6gOv3eD"
                       >FORMULARIO</Button>
                <br/>
                <Button className="EvColorGrisLight m-1" onClick={props.volver}
                        variant="light">{getMessage('ask_again', props.messages)}</Button>
            </Col>
        </Row>
    )
}

export default NotFound;